import { IModularityUtilConfigurator } from "./IModularityUtilConfigurator";
import { ModularityUtilConfigurator } from "./ModularityUtilConfigurator";
/**
 * Created by rkamysz on 4/30/2015.
 */

import { CommandController } from './../../../commanding/CommandController';
// TODO: @HTML5 classes don't exist in robotlegs module
// import { IModuleCommandMap } from "../../../robotlegs/modular/moduleSignalCommandMap/api/IModuleCommandMap";
// import { IModuleCommandConfigurator } from "../../../robotlegs/modular/moduleSignalCommandMap/dsl/IModuleCommandConfigurator";

// import { IContext } from "robotlegs";

export class ModularityUtil {
    // private static _moduleCommandMap: IModuleCommandMap; TODO: @HTML5 classes don't exist in robotlegs module
    // private static _context: IContext;

    public static mapOutput(moduleInterface: Object, signalGetter: string): IModularityUtilConfigurator {
        // TODO: @HTML5 classes don't exist in robotlegs module
        // let conf: IModuleCommandConfigurator = ModularityUtil._moduleCommandMap.mapOutput(moduleInterface, signalGetter).toInput(CommandController, "executeCommand");
        let conf: any;
        return new ModularityUtilConfigurator(conf);
    }

    /*public static initialize(context: IContext): void {
        ModularityUtil._context = context;
        // TODO: @HTML5 classes don't exist in robotlegs module
        // ModularityUtil._moduleCommandMap = ModularityUtil._context.injector.getInstance(IModuleCommandMap);
        // ModularityUtil._context.injector.map(CommandController).toValue(CommandController.instance);
    }

    public static get context(): IContext {
        return ModularityUtil._context;
    }*/

    public static get context(): any {
        return null;
    }
}

